class Select extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');
    this.select.addEventListener('change', this.onToggle.bind(this));

    this.checkSelectValue()
  }

  checkSelectValue() {
    if (this.select.name.includes('country') || this.select.name.includes('prefix')) {
      const dataValue = this.select.dataset.value
      const option = this.select.querySelector(`option[value="${dataValue}"]`)
      option?.setAttribute('selected', true)
    }
  }

  onToggle() {
    if (this.select.value && this.select.value !== '') {
      this.select.classList.add('has-value');
    } else {
      this.select.classList.remove('has-value');
    }
  }
}

customElements.define('select-item', Select);
